import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const ghostConsumerAnalysisSlice = createApi({
  reducerPath: "analysis_ghost_consumer",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["ghost_consumer"],
  endpoints: (build) => ({
    getGhostConsumerSummary: build.query({
      query: ({ orgId, headers, payload }) => ({
        // url: `bank/${orgId}/dashboard?card=ghost_consumer&view=summary&page=0&size=10`,
        url:`/bank/${orgId}/dashboard/${payload.requid}/ghost_consumer/summary`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),

    getGhostConsumerExpanded: build.query({
      query: ({ orgId, headers, payload }) => ({
        // url: `bank/${orgId}/dashboard?card=ghost_consumer&view=expand&page=0&size=10`,
        url:`/bank/${orgId}/dashboard/${payload.requid}/ghost_consumer/expand`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetGhostConsumerSummaryQuery,
  useGetGhostConsumerExpandedQuery,
} = ghostConsumerAnalysisSlice;
